import React from "react";
import { CImage } from "@app/components/Common";
import { COLORS, IMAGES, SIZES } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import { useTranslation } from "react-i18next";

const ProfileUserDetail = () => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        minHeight: "50px",
      }}
    >
      <CImage
        src={IMAGES.eventImage}
        alt="logo"
        width={50}
        height={50}
        resizeMode={"cover"}
        style={{ borderRadius: 50, marginRight: 10, flexShrink: 0 }}
      />

      <View
        style={{
          alignItems: "flex-start",
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Text
          style={{
            fontSize: SIZES.h5,
            lineHeight: 1.5,
            fontWeight: "600",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Mickey
        </Text>
        <View
          style={{
            flexDirection: "row",
            gap: "8px",
            width: "100%",
            flexWrap: "nowrap",
          }}
        >
          <Text
            style={{
              fontSize: SIZES.h7,
              whiteSpace: "nowrap",
            }}
          >
            924 {t("followerss")}
          </Text>
          <Text
            style={{
              fontSize: SIZES.h7,
              color: COLORS.lightGreen,
              whiteSpace: "nowrap",
            }}
          >
            1.20%
          </Text>
        </View>
      </View>
    </View>
  );
};

export default React.memo(ProfileUserDetail);
